// Export Types
export const CLEAR_FEEDBACK = 'CLEAR_FEEDBACK';
export const POST_FEEDBACK_REQUEST = 'POST_FEEDBACK_REQUEST';
export const POST_FEEDBACK_SUCCESS = 'POST_FEEDBACK_SUCCESS';
export const POST_FEEDBACK_FAILURE = 'POST_FEEDBACK_FAILURE';
